module.exports = __webpack_public_path__ + "static/img/rgb.12bf452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rgb.png
// module id = K9AO
// module chunks = 7